import jQuery from 'jquery';

jQuery(($) => {
    const pageClass = 'Page-ApplicationReviewProgram';
    const outputClass = `${pageClass}__ApplicationOutput`;
    const downloadAllFilesClass = `${pageClass}__ApplicationsDownloadAllFiles`;
    const downloadAllFilesInProgressClass = `${downloadAllFilesClass}--InProgress`;

    function init() {
        const $page = $(`.${pageClass}`);

        if ($page.length === 0) {
            return;
        }

        function saveAs(blob, filename) {
            const url = URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = url;
            a.download = filename;
            document.body.appendChild(a);
            a.click();
            a.remove();
            setTimeout(() => URL.revokeObjectURL(url), 0);
        }

        // Sum output

        const $idehojd = $page.find('[name="Id_h_jd__c"]');
        const $utforande = $page.find('[name="Utf_rande__c"]');
        const $relevans = $page.find('[name="Relevans__c"]');
        const $output = $page.find(`.${outputClass}`);

        $idehojd
            .add($utforande)
            .add($relevans)
            .change(() => {
                let sum =
                    parseInt($idehojd.val(), 10) +
                    parseInt($utforande.val(), 10) +
                    parseInt($relevans.val(), 10);

                if (Number.isNaN(sum)) {
                    sum = '-';
                }

                $output.text(sum);
            });

        // Block navigation on unsaved changes

        let confirm = false;

        $page.find('select, textarea').on('change', () => {
            confirm = true;
        });

        $page.find('form').on('submit', () => {
            confirm = false;
        });

        $(window).on('beforeunload', () => {
            if (!confirm) {
                return;
            }

            return $page.data('beforeunloadMessage');
        });

        // File download

        function downloadFile(file, error, completed) {
            const xhr = new XMLHttpRequest();
            xhr.open('GET', file.url);
            xhr.responseType = 'blob';
            xhr.onerror = error;
            xhr.onload = function () {
                saveAs(xhr.response, file.name);
                completed();
            };

            xhr.send();
        }

        $page.find(`.${downloadAllFilesClass}`).click(function (event) {
            event.preventDefault();

            const $this = $(this);

            if ($this.hasClass(downloadAllFilesInProgressClass)) {
                return;
            }

            if (!window.confirm($page.data('downloadAllFilesConfirmMessage'))) {
                return;
            }

            $this.addClass(downloadAllFilesInProgressClass);

            const queue = $page.data('allFiles');

            function downloadNextFile() {
                const file = queue.shift();

                if (!file) {
                    window.alert($page.data('downloadAllFilesSuccessMessage'));
                    $this.removeClass(downloadAllFilesInProgressClass);
                    return;
                }

                downloadFile(
                    file,
                    () => {
                        window.alert(
                            $page.data('downloadAllFilesErrorMessage'),
                        );
                        $this.removeClass(downloadAllFilesInProgressClass);
                    },
                    downloadNextFile,
                );
            }

            downloadNextFile();
        });
    }

    init();
});
